import React from "react";
import { Box } from "@mui/material";
import "./SubTitle.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export default function SubTitle({
  title,
  path = "",
  add,
  addPath,
  track,
  trackPath,
  onAddClick,
  onTrackClick,
  breadcrumbHandlers = {},
  type = null,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getBreadcrumbNavigationTarget = (pathSegment, index, segments) => {
    const trimmedSegment = pathSegment.trim();

    // First segment (organization) should always go to dashboard
    if (index === 0) {
      return { to: "/dashboard" };
    }

    // Don't navigate for the last segment (current page)
    if (index === segments.length - 1) {
      return null;
    }

    const customHandler = breadcrumbHandlers[trimmedSegment];
    if (customHandler) {
      if (typeof customHandler === "string") {
        return { to: customHandler };
      }

      if (typeof customHandler === "object" && customHandler.to) {
        return customHandler;
      }
    }

    const pathMap = {
      Routes: "/route",
      Vehicles: "/vehicle",
      Stops: "/stop",
      Users: "/user",
      Schedules: "/schedule",
      Reports: "/reports",
      Sites: "/site",
      "Manage Roles": "/user/role",
      "Data Management": "/reports/managedata",
      "Trip Replays": "/replay",
      "Organizations": "/org",
       "New Request": "/admin",
       "Devices": "/device",
    };

    const mappedPath = pathMap[trimmedSegment];
    return mappedPath ? { to: mappedPath } : null;
  };

  // Function to handle breadcrumb navigation
  const handleBreadcrumbClick = (pathSegment, index, segments) => {
    const target = getBreadcrumbNavigationTarget(pathSegment, index, segments);
    if (!target) {
      return;
    }

    navigate(target.to, {
      state: target.state,
      replace: target.replace,
    });
  };

  // Function to render clickable breadcrumbs
  const renderBreadcrumbs = (path) => {
    const segments = path.split(">");

    return segments.map((segment, index) => {
      const isClickable = Boolean(
        getBreadcrumbNavigationTarget(segment, index, segments),
      );

      return (
        <React.Fragment key={index}>
          <span
            className={`subtitle-breadcrumb ${isClickable ? "clickable" : ""}`}
            onClick={() => handleBreadcrumbClick(segment, index, segments)}
          >
            {t(segment.trim())}
          </span>
          {index < segments.length - 1 && (
            <span className="subtitle-separator"> &gt; </span>
          )}
        </React.Fragment>
      );
    });
  };

  const handleAddClick = () => {
    if (onAddClick) {
      onAddClick(addPath);
    }
  };

  const handleTrackClick = () => {
    if (onTrackClick) {
      onTrackClick(trackPath);
    }
  };

  return (
    <div className="subtitle-container">
      <div className="subtitle-left-content">
        <Box>
          <span className="subtitle-text">{t(title)}</span>
          <div className="subtitle-path">{renderBreadcrumbs(path)}</div>
        </Box>
      </div>

      <div className="subtitle-buttons">
        {track && (
          <button
            className="subtitle-secondary-btn"
            onClick={handleTrackClick}
            variant="contained"
            style={{
              fontFamily: "Roboto",
              fontWeight: 600,
              fontSize: "20px",
            }}
          >
            {t(track)}
          </button>
        )}

        {add && (
          <button
            className="subtitle-primary-btn"
            onClick={handleAddClick}
            variant="contained"
            style={{
              fontFamily: "Roboto",
              fontWeight: 600,
              fontSize: "20px",
            }}
          >
            {t(add)}
          </button>
        )}
      </div>
    </div>
  );
}
